import React, { useContext } from "react";
import styled from "styled-components";
import { FlexRow } from '@components/layout/FlexStyles';
import { TextRegular, TextSmall, TextSmallItalics, TextTiny } from '@components/elements/TextStyles';
import { CreditsContext } from "@stores/CreditsContext";
import PagePanel from '@components/pages/PagePanel';
import creditsCards from "@components/composite/HeaderCredits/credits.config";
import CreditsCard from "@components/composite/HeaderCredits/credits.card";

const debug = false;
const NewUser = () => {
  const { creditsInfo } = useContext(CreditsContext);
  debug && console.log("HeaderCredits | {creditsInfo}", creditsInfo);
  const card = creditsCards.find((c) => c.title === 'Add Credits')

  return (
    <PagePanel>
      <NewUserContainer>
        <FlexRow><TextRegular color={'accent'}>Welcome to SciScore</TextRegular></FlexRow>
        <FlexRow v_centered>
          <TextContent>
            <TextSmall>As a new user, you will need credits to be
              able to submit your methods and materials sections for analysis.
            </TextSmall>
            <TextTiny>Credits are purchased in groups of three (3) and one (1) credit
              is needed for each submission for analysis.
            </TextTiny>
            <TextSmallItalics color={'primary'}>
              Click the button to the right to purchase credits to begin.
            </TextSmallItalics>
          </TextContent>
          <CardContent>
            <CreditsCard
              key = 'newuser_but_credits'
              card = {card}
              values = {creditsInfo}
            />
          </CardContent>
        </FlexRow>
      </NewUserContainer>
    </PagePanel>
  );
};

export default NewUser;

const NewUserContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: calc(100% - 50px);
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px
`;

const CardContent = styled.div`
  display: flex;
  width: 300px;
`;
